<div class="loading">
  <img src="/assets/img/logo_only_tv_package_page_app4.png" /><br />
  <div class="row">
    <h3>{{ message1 }}</h3>
    <p>{{ message2 }}</p>
  </div>
</div>
